module.exports = __webpack_public_path__ + "assets/img/5b7743c4bdc19df0c67655bdb24a7e6d.png";